import { type ArtSet, GOLD_ASSETS } from './constants/theme';

type DeployEnv = 'local' | 'dev' | 'prod';

// Color-coded favicon per environment so local/dev/prod tabs are distinguishable.
const FAVICON_BY_ENV: Partial<Record<DeployEnv, string>> = {
  local: '/favicon-local.png',
  dev: '/favicon-dev.png',
};

const DEFAULT_FAVICON_PATHS = ['/favicon.ico', '/favicon-32x32.png', '/favicon-16x16.png'];
const ART_ICON_PATHS = [...DEFAULT_FAVICON_PATHS, '/apple-touch-icon.png'];

const splitHref = (href: string) => {
  const classic = href.startsWith(`${GOLD_ASSETS}/`) ? href.slice(GOLD_ASSETS.length) : href;
  const [path, query] = classic.split('?');
  return { classic, path, query: query === undefined ? '' : `?${query}` };
};

const replaceHrefs = (html: string, rewrite: (href: string) => string): string =>
  html.replace(/href="([^"]+)"/g, (_, href: string) => `href="${rewrite(href)}"`);

export const swapEnvFavicon = (html: string, env: DeployEnv): string => {
  const favicon = FAVICON_BY_ENV[env];
  if (!favicon) {
    return html;
  }
  return replaceHrefs(html, (href) => {
    const { path, query } = splitHref(href);
    return DEFAULT_FAVICON_PATHS.includes(path) ? `${favicon}${query}` : href;
  });
};

/** Points a favicon href at the icon of the art set. Other hrefs, such as the env favicons, stay. */
export const artIconHref = (href: string, art: ArtSet): string => {
  const { classic, path } = splitHref(href);
  if (!ART_ICON_PATHS.includes(path)) {
    return href;
  }
  return art === 'gold' ? `${GOLD_ASSETS}${classic}` : classic;
};

export const swapArtFavicon = (html: string, art: ArtSet): string =>
  replaceHrefs(html, (href) => artIconHref(href, art));
